import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-t', 'LetterT', [["path",{"d":"M8 7h3.75m0 0h3.75m-3.75 0v10","key":"svg-0"}]]);